import { render } from "./ServiceComponent.vue?vue&type=template&id=604fc02a&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"

import "./ServiceComponent.vue?vue&type=style&index=0&id=604fc02a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604fc02a"]])

export default __exports__